import React from "react";
import classnames from "classnames";
import Isvg from "../../../../vendor/react-inlinesvg";
import OverleafAction from "../../../actions/overleaf-action";
import OverleafStore from "../../../stores/overleaf-store";
import { TransitionGroup, Transition } from "react-transition-group";
import gsap from "gsap";

var slideTimer;
const rando = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
};

function faceEnterAnimation(node, final) {
  if (final) {
    const startFace = { y: 100, opacity: 0 };
    const buttonStart = { y: 0, opacity: 0 };
    const endPosition = { y: 0, opacity: 1 };
    const animations = {
      1: { time: 0.3, startAni: startFace, endAni: endPosition },
      2: { time: 0.6, startAni: startFace, endAni: endPosition },
      3: { time: 1.5, startAni: buttonStart, endAni: endPosition },
      4: { time: 1.5, startAni: buttonStart, endAni: endPosition }
    };
    return gsap.fromTo(
      node,
      animations[final].time,
      animations[final].startAni,
      animations[final].endAni
    );
  }
  return gsap.fromTo(
    node,
    0.6,
    { y: 100, opacity: 0 },
    { y: 0, opacity: 1 }
  );
}

function faceExitAnimation(node) {
  return gsap.fromTo(
    node,
    0.3,
    { opacity: 1 },
    { opacity: 0 }
  );
}

class Face extends React.Component {
  render() {
    let faceImage = (!this.props.final || this.props.final < 3) &&
      !this.props.text && (
        <Isvg
          className="one-face"
          key={`face-${this.props.image}`}
          src={this.props.image}
        />
      );
    let mainSubHead = !this.props.final && this.props.image && this.props.text && (
      <div id="main-header" key={`text-${this.props.image}`}>
        {this.props.text}
      </div>
    );
    let studyAgainBtn = this.props.final === 3 && (
      <div id="study-again">{this.props.text}</div>
    );
    let backToBook = this.props.final === 4 && (
      <div id="back-to-book">{this.props.text}</div>
    );

    return (
      <div>
        {faceImage}
        {mainSubHead}
        {studyAgainBtn}
        {backToBook}
      </div>
    );
  }
}

class CompletionSlide extends React.Component {
  constructor() {
    super();
    this.floatBackground = this.floatBackground.bind(this);

    this.state = {
      slideNumber: 0
    };
  }

  getSlides() {
    return [
      {
        mainhead: i18n.t("flashcards.review-complete"),
        subhead: i18n.t("flashcards.breakdown"),
        className: "overview",
        duration: 3000,
        imageOne: "img/bg_sparkle.svg",
        imageTwo: null,
        imagethree: null,
        btnOne: null
      },
      {
        mainhead: i18n.pluralize(
          this.props.stats.confident,
          "flashcards.cards-correct-singular",
          "flashcards.cards-correct"
        ),
        subhead: null,
        className: "correct",
        duration: 3000,
        imageOne: "img/bg_star.svg",
        imageTwo: "img/face_ball_green.svg",
        imageThree: null,
        btnOne: null
      },
      {
        mainhead: i18n.pluralize(
          this.props.stats.notConfident,
          "flashcards.cards-wrong-singular",
          "flashcards.cards-wrong"
        ),
        subhead: null,
        className: "wrong",
        duration: 3000,
        imageOne: "img/bg_heart.svg",
        imageTwo: "img/face_ball_red.svg",
        imageThree: null,
        btnOne: null
      },
      {
        mainhead: i18n.t("flashcards.review-complete"),
        subhead: i18n.t("flashcards.breakdown"),
        className: "breakdown",
        duration: 3000,
        imageOne: "img/bg_sparkle.svg",
        imageTwo: "img/face_ball_red.svg",
        imageFour: "img/face_ball_green.svg",
        btnOne: (
          <button
            className="noButton breakdown-btn"
            onClick={() => {
              this.props.filterDeck(OverleafStore.CONFIDENCE.NOT_CONFIDENT);
              Fraction.Reporter.noticeInteraction(
                "flashcards-study-weak-cards",
                { deckId: this.props.deckId }
              );
            }}
          >
            {i18n.t("flashcards.study-weak-cards")}
          </button>
        ),
        btnTwo: (
          <button
            className="noButton breakdown-btn"
            onClick={this.props.closeFlashCards}
          >
            {i18n.t("flashcards.close-deck")}
          </button>
        )
      }
    ];
  }

  componentDidMount() {
    const finalSlide = this.getSlides().length - 1;
    this.playSlides(finalSlide);
    this.startAnimation();
  }

  floatBackground(rows, columns, floaters) {
    let style, top, left;
    let floaties = [];
    let i = 0;
    let colCounter = 0;
    let rowCounter = 0;
    let image = this.getSlides()[this.state.slideNumber].imageOne;

    let columnWidth =
      document.getElementById("bookshelf").offsetWidth / columns;
    let rowHeight = document.getElementById("bookshelf").offsetHeight / rows;

    while (colCounter < columns) {
      while (rowCounter < rows) {
        while (i < floaters) {
          top = () => {
            return rando(
              rowCounter * rowHeight,
              rowCounter * rowHeight + rowHeight
            );
          };
          left = () => {
            return rando(
              colCounter * columnWidth,
              colCounter * columnWidth + columnWidth
            );
          };
          const randomScale = Math.random();
          style = {
            top: top(),
            left: left(),
            opacity: Math.random(),
            transform: `scale(${randomScale}, ${randomScale})`
          };

          floaties.push(
            <img
              key={`floater-${colCounter}-${rowCounter}-${i}`}
              className="floater-element"
              style={style}
              src={image}
            />
          );
          i++;
        }
        i = 0;
        rowCounter++;
      }
      rowCounter = 0;
      colCounter++;
    }
    return floaties;
  }

  makeNewPosition(bounds, $element) {
    let maxTop = bounds[1] + 10;
    let minTop = bounds[1] - 10 < 0 ? 0 : bounds[1] - 10;
    let maxleft = bounds[0] + 10;
    let minleft = bounds[0] - 10 < 0 ? 0 : bounds[0] - 10;

    var newHeight = rando(minTop, maxTop);
    var newWidth = rando(minleft, maxleft);

    return [newHeight, newWidth];
  }

  animateImage(bounds, $target) {
    var newPosition = this.makeNewPosition(bounds, $target);
    var oldPosition = $target.offset();
    var speed = this.calcSpeed(
      [oldPosition.top, oldPosition.left],
      newPosition
    );
    var that = this;

    $target.animate(
      {
        top: newPosition[0],
        left: newPosition[1]
      },
      speed,
      function () {
        that.animateImage(bounds, $target);
      }
    );
  }

  calcSpeed(prev, next) {
    var x = Math.abs(prev[1] - next[1]);
    var y = Math.abs(prev[0] - next[0]);

    var greatest = x > y ? x : y;
    var speedModifier = 0.01;
    var speed = Math.ceil(greatest / speedModifier);

    return speed;
  }

  playSlides(index) {
    const timerLength = this.getSlides()[index].duration;
    const counter = this.getSlides().length - 1;

    this.setState({ slideNumber: index });
    slideTimer = setTimeout(() => {
      if (index < counter) {
        this.playSlides(index + 1);
      }
    }, timerLength);
  }

  skipToEnd() {
    this.setState({ slideNumber: this.getSlides().length - 1 });
    clearTimeout(slideTimer);
    Fraction.Reporter.noticeInteraction("flashcards-skip-completion-slides", {
      deckId: this.props.deckId
    });
  }

  startAnimation() {
    // All items on DOM now
    let allFloaters = document.getElementsByClassName("floater-element");
    allFloaters = [].slice.call(allFloaters);
    allFloaters.forEach(element => {
      let top = parseInt(element.style.top),
        left = parseInt(element.style.left);

      this.animateImage([left, top], $(element));
    });
  }

  render() {
    let currentSlide = this.getSlides()[this.state.slideNumber];
    let finalSlide = this.state.slideNumber === this.getSlides().length - 1;

    return (
      <div id="overleaf">
        <div id="complete" className={currentSlide.className}>
          {this.floatBackground(3, 3, 3)}
          <TransitionGroup>
            {!finalSlide && currentSlide.imageTwo && (
              <Transition
                key={`face-${currentSlide.imageTwo}`}
                timeout={{ enter: 600, exit: 300 }}
                onEnter={(node) => faceEnterAnimation(node)}
                onExit={(node) => faceExitAnimation(node)}
                unmountOnExit
              >
                <Face
                  image={currentSlide.imageTwo}
                />
              </Transition>
            )}
          </TransitionGroup>
          <TransitionGroup>
            {!finalSlide && currentSlide.imageTwo && (
              <Transition
                key={`text-${currentSlide.imageTwo}`}
                timeout={{ enter: 600, exit: 300 }}
                onEnter={(node) => faceEnterAnimation(node)}
                onExit={(node) => faceExitAnimation(node)}
                unmountOnExit
              >
                <Face
                  image={true}
                  text={currentSlide.mainhead}
                  id="main-header"
                />
              </Transition>
            )}
          </TransitionGroup>

          {(currentSlide.className === "overview" ||
            currentSlide.className === "breakdown") && (
            <h2 id="stationary-main-header">{currentSlide.mainhead}</h2>
          )}
          <div id="sub-header">{currentSlide.subhead}</div>

          <div id="all-faces">
            <div id="red-face">
              <TransitionGroup>
                {finalSlide && (
                  <Transition
                    key={`final-face-${currentSlide.imageTwo}`}
                    timeout={{ enter: 300, exit: 300 }}
                    onEnter={(node) => faceEnterAnimation(node, 1)}
                    onExit={(node) => faceExitAnimation(node)}
                    unmountOnExit
                  >
                    <Face
                      final={1}
                      image={currentSlide.imageTwo}
                    />
                  </Transition>
                )}
              </TransitionGroup>
              {finalSlide && (
                <div className="tally">
                  <span className="offScreen">
                    {i18n.t("flashcards.flashcard-tally", {
                      confidence: i18n.t("flashcards.confidence--1")
                    })}
                  </span>
                  {this.props.stats.notConfident}
                </div>
              )}
            </div>
            <div id="green-face">
              <TransitionGroup>
                {finalSlide && (
                  <Transition
                    key={`final-face-${currentSlide.imageFour}`}
                    timeout={{ enter: 600, exit: 300 }}
                    onEnter={(node) => faceEnterAnimation(node, 2)}
                    onExit={(node) => faceExitAnimation(node)}
                    unmountOnExit
                  >
                    <Face
                      final={2}
                      image={currentSlide.imageFour}
                    />
                  </Transition>
                )}
              </TransitionGroup>
              {finalSlide && (
                <div className="tally">
                  <span className="offScreen">
                    {i18n.t("flashcards.flashcard-tally", {
                      confidence: i18n.t("flashcards.confidence-1")
                    })}
                  </span>
                  {this.props.stats.confident}
                </div>
              )}
            </div>
          </div>

          <TransitionGroup>
            {finalSlide && (
              <Transition
                key="final-start-over"
                timeout={{ enter: 1500, exit: 300 }}
                onEnter={(node) => faceEnterAnimation(node, 4)}
                onExit={(node) => faceExitAnimation(node)}
                unmountOnExit
              >
                <Face
                  final={4}
                  text={currentSlide.btnTwo}
                />
              </Transition>
            )}
          </TransitionGroup>
          {!finalSlide && (
            <button
              id="skip"
              className="noButton"
              onClick={this.skipToEnd.bind(this)}
            >
              {i18n.t("flashcards.skip")}
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default CompletionSlide;
